// extracted by mini-css-extract-plugin
module.exports = {"slider-container":"Slider_slider-container__2gRen","slider-cover":"Slider_slider-cover__18vRQ","slider":"Slider_slider__1Aa5c"};